import styled from 'styled-components';
import { Card, Flex, Text } from '@amzn/storm-ui';
import { AMAZON_NAV_INKWELL } from '../../constants/commonConstants';

export const Container = styled(Card)`
  background: ${AMAZON_NAV_INKWELL};
  border-radius: 0;
  > div {
    padding: 0 0.5rem;
  }
  color: ${({ theme }) => theme.color.gray[50]};
  justify-content: space-between;
  border: 0 solid ${AMAZON_NAV_INKWELL};
  border-bottom: 0.2rem solid ${({ theme }) => theme.color.clementine[500]};
`;

export const FlexContainer = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

export const AmazonLogo = styled.img`
  height: 1.625rem;
  flex-shrink: 0;
  padding-left: 0.5rem;
`;

export const StyledText = styled(Text)`
  color: ${({ theme }) => theme.color.gray[0]};
`;
